<template>
  <div class="warper">
    <div class="card_list">
      <div class="card_item" v-for="item in tableData" :key="item.id">
        <div class="top_row">
          {{ item.agreeName }}
        </div>
        <div class="center_row">
          <p v-html="item.agreeInfoGrammar" class="line2"></p>
        </div>
        <div class="bottom_row">
          <div class="row_left">
            <i class="iconfont fontSize18 icon-shijian"></i>
            <span>创建时间：{{ item.agreeCretime }}}</span>
          </div>
          <div class="row_right" @click="editXy(item)">
            <i class="iconfont fontSize24 col-999 icon-bianji"></i>
          </div>
        </div>
      </div>
    </div>

    <Edit ref="editRef" v-if="isEdit" @getData="getData"/>


  </div>
</template>
<script>
import {
  computed,
  defineComponent,
  reactive,
  toRefs,
  nextTick,
  onMounted,
  getCurrentInstance,
} from "vue";
import { useStore } from "vuex";
import { apiObj } from "@/config/api";
import zhCn from "element-plus/es/locale/lang/zh-cn";
import Edit from './components/edit.vue'
export default defineComponent({
  name: "xyList",
  components:{Edit},
  setup() {
    const store = useStore();
    const { proxy } = getCurrentInstance();
    const data = reactive({
      tableData: [],
      isEdit:false
    });
    //列表
    const getData = async () => {
      const params = {
        searchWord: "",
        page: 1,
        limit: 10000,
      };
      const r = await proxy.$http.get(apiObj.xyList, params);
      console.log(r);
      if (r.code === 0) {
        data.tableData = r.rows;
      }
    };
    //编辑协议
    const editXy=(item)=>{
        data.isEdit=true
        nextTick(()=>{
            proxy.$refs.editRef.init(item)
        })
    };
    onMounted(() => {
        getData();
    });
    return {
      ...toRefs(data),
      getData,
      editXy
    };
  },
});
</script>
<style scoped>
.warper {
  width: 100%;
  height: 100%;
  background: #fff;
}
.card_list {
  width: 100%;
  height: calc(100% - 50px);
  margin: 15px auto;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}
.card_item {
  width: 24%;
  margin: 0 20px 10px 0;
  padding: 10px 20px;
  box-shadow: 0px 0px 7px 0px rgb(0 0 0 / 16%);
  border-radius: 1px;
  position: relative;
  background: #fff;
}
.card_item .top_row {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #f1f1f1;
  font-size: 15px;
  font-weight: bold;
}
.card_item .center_row {
  width: 100%;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: flex-start;

}
.card_item .center_row p {
  font-size: 13px;
  color: #999999;
}
.card_item .center_row h1 {
  font-size: 13px;
  color: #999999;
}
.card_item .bottom_row {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.card_item .bottom_row .row_left {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.card_item .bottom_row .row_left span {
  display: inline-block;
  color: #999999;
  font-size: 13px;
  margin-left: 5px;
}
.card_item .bottom_row .row_right {
  position: relative;
  cursor: pointer;
}

</style>
